namespace advisorop.components.servicer {

    export class OrionAccSyncMonitorController {
        dgData: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;

        // grid instance
        dgInst: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#orionAccSyncMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "OrionAccSyncMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.dgData",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgNegCashMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 30 },
                    { dataField: "representative", caption: "Advisor", width: 120 },
                    { dataField: "number", caption: "Account Number", width: 120 },
                    { dataField: "name", caption: "Account Name", width: 300 },
                    { dataField: "accountStartDate", caption: "Start date", headerCellTemplate: (h, info) => { $(h).attr("title", "Sourced from Orion").append($("<span>").text(info.column.caption || "")); }, width: 80, dataType: 'date', format: 'shortDate', visible: true },
                    { dataField: "createdDate", caption: "Created Date", width: 80, dataType: 'date', format: 'shortDate', visible: true },
                    { dataField: "rr", caption: "RR#", width: 80, visible: true },
                    { dataField: "custodian", caption: "Custodian", width: 100, visible: true },
                    { dataField: "currentValue", caption: "Value", format: { type: "currency", precision: 2 }, width: 100 },
                    {
                        caption: "Days Since Created",
                        width: 120,
                        alignment: 'center',
                        allowSorting: true,
                        calculateSortValue: function (rowData: any) {
                            if (!rowData.createdDate) return -1;
                            var startDate = new Date(rowData.createdDate);
                            if (isNaN(startDate.getTime())) return -1;
                            return Math.floor((new Date().getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
                        },
                        calculateCellValue: function (rowData: any) {
                            if (!rowData.createdDate) return "No date";
                            var startDate = new Date(rowData.createdDate);
                            if (isNaN(startDate.getTime())) return "Invalid date";
                            var today = new Date();
                            var days = Math.floor((today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));
                            if (days < 0) return "Not yet open";
                            var years = Math.floor(days / 365);
                            var remaining = days % 365;
                            var months = Math.floor(remaining / 30);
                            var remDays = remaining % 30;
                            var parts: string[] = [];
                            if (years > 0) parts.push(years + (years === 1 ? " year" : " years"));
                            if (months > 0) parts.push(months + (months === 1 ? " month" : " months"));
                            if (remDays > 0 || parts.length === 0) parts.push(remDays + (remDays === 1 ? " day" : " days"));
                            return parts.join(", ");
                        }
                    },
                ],
                masterDetail: {
                    enabled: true,
                    template: "sleeves",
                    autoExpandAll: false
                },
                onCellPrepared: this.oncp
            };

        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            console.log(`Report: ${report} Level ${level}, account: ${account}`);
            this.servicerService.calculateOrionParamsAsync(level, account.accountId).then(params => {
                this.servicerService.openOrionReport(report, params);
            });
        }

        oncp = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        loadDgData() {

            this.mvDate = null;
            let rez: any;
            this.isInitializing = true;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                rez = this.servicerService.getOrionAccSyncMonitorData(this.advisoryFirmId);
            }

            rez.then(response => {
                this.dgData = response.data;
                if (this.dgData.length > 0) {
                    this.issuesCount = this.dgData.length;
                }
                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadDgData();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.dgData);
                //}
            }
        };
    }


    class OrionAccSyncMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = OrionAccSyncMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/orion-acc-sync-monitor.html";
        }
    }
    angular.module(Constants.APP).component("orionAccSyncMonitor", new OrionAccSyncMonitor());

}